'use strict';

var _rollupPluginBabelHelpers = require('../../../_rollupPluginBabelHelpers-D-dvSLAU.js');

var _excluded = ["headers"];
/**
 * Wrap a fetch function to automatically add the Authorization header
 *   based on the JWT token resulting from the `getJwtToken` function.
 *
 * @param options - {@see CreateLoggedInFetchOptions}
 */
var createLoggedInFetch = function createLoggedInFetch(_ref) {
  var getJwtToken = _ref.getJwtToken,
    fetchFunction = _ref.fetchFunction;
  return /*#__PURE__*/function () {
    var _ref2 = _rollupPluginBabelHelpers._asyncToGenerator(/*#__PURE__*/_rollupPluginBabelHelpers._regeneratorRuntime().mark(function _callee(info) {
      var _ref3,
        requestHeaders,
        init,
        onUnauthorized,
        headers,
        jwtToken,
        response,
        _args = arguments;
      return _rollupPluginBabelHelpers._regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref3 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {
              headers: {}
            }, requestHeaders = _ref3.headers, init = _rollupPluginBabelHelpers._objectWithoutProperties(_ref3, _excluded);
            onUnauthorized = _args.length > 2 ? _args[2] : undefined;
            headers = new Headers(requestHeaders); // Set the Authorization header if a token is present
            jwtToken = getJwtToken();
            if (jwtToken) {
              headers.set('Authorization', "Bearer ".concat(jwtToken));
            }
            // Set the Content-Type header to JSON if it is not already set
            if (!headers.has('Content-Type')) {
              headers.append('Content-Type', 'application/json');
            }
            // Fallback to the global fetch function if none is provided
            _context.next = 8;
            return (fetchFunction || fetch)(info, _rollupPluginBabelHelpers._objectSpread2({
              headers: headers
            }, init));
          case 8:
            response = _context.sent;
            if (!(response.status === 401 && onUnauthorized)) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", onUnauthorized(response));
          case 11:
            return _context.abrupt("return", response);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.createLoggedInFetch = createLoggedInFetch;
//# sourceMappingURL=index.js.map
